import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TramiteSicProteccionConsumidorDto } from '../../../../../dto/tramites/tramite-sic-proteccion-consumidor.dto';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from '../../../../../constants/constants';
import { AlertaModalService } from '../../../../../services/util/alerta-modal.service';

@Component({
  selector: 'app-fundamentos-de-derecho',
  templateUrl: './fundamentos-de-derecho.component.html',
  styleUrl: './fundamentos-de-derecho.component.scss',
})
export class FundamentosDeDerechoComponent implements OnInit {
  @Input() tramiteSic?: TramiteSicProteccionConsumidorDto;
  @Output() continuar = new EventEmitter<{
    tramite: TramiteSicProteccionConsumidorDto;
    formValid: boolean;
    event: Event;
  }>();
  @Output() guardarSinEnviar = new EventEmitter<{
    tramite: TramiteSicProteccionConsumidorDto;
    formValid: boolean;
    event: Event;
  }>();

  formFundamentos!: FormGroup;
  // Multilenguaje
  proconText: any = {};
  alertaText: any = {};
  constructor(
    private fb: FormBuilder,
    private readonly translate: TranslateService,
    private readonly alertaModalService: AlertaModalService
  ) { }

  ngOnInit() {
    this.translate.stream('alertas').forEach(text => {
      for (const key of Object.keys(text)) {
        this.alertaText[key] = text[key];
      }
    });
    this.translate.stream('tramites').forEach(text => {
      for (const key of Object.keys(text)) {
        this.proconText[key] = text[key];
      }
      this.formFundamentos = this.fb.group({
        fundamentosDerechos: [
          this.proconText['tramite-sic-procon']['fundamentos-derechos'],
          Validators.required,
        ],
      });
    });
  }
  anterior() {
    let paso = +JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
    if (paso) {
      paso--;
      sessionStorage.setItem(Constants.PASOS, JSON.stringify(paso));
    }
  }

  onClickFundamentos(event: Event) {
    if (this.formFundamentos.invalid) {
      this.formFundamentos.markAllAsTouched();
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      return;
    }

    // Valido → continúa flujo
    this.pasarAPruebas(event, false);
  }

  pasarAPruebas(e: Event, guardarSinEnviar: boolean) {
    let paso = +JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
    if (paso) {
      sessionStorage.setItem(Constants.PASOS, JSON.stringify(7));
    }
    const tramite: TramiteSicProteccionConsumidorDto = {
      fundamentosDerechos: this.formFundamentos.value['fundamentosDerechos'],
    };

    if (!guardarSinEnviar) {
      this.continuar.emit({
        tramite: tramite,
        formValid: true,
        event: e,
      });
    } else {
      this.guardarSinEnviar.emit({
        tramite: tramite,
        formValid: true,
        event: e,
      });
    }
  }
}
